import React from 'react';
import _ from 'lodash';

/**
 * UserAvatar component
 *
 * Renders only what it's given. Inside admin pages prefer UserAvatarLive, which completes stored
 * { id, username } signatures with the users info service (level → bot badge, isPremium).
 *
 * @param {Object} props - Component props
 * @param {string | {username: string, id: string, isPremium?: boolean}} [props.user] - User object containing username and id
 * @param {string} [props.id] - User ID
 * @param {boolean} [props.isPremium] - Overlay a 💎 premium badge on the avatar (defaults to user.isPremium)
 * @param {boolean} [props.isBot] - Overlay a 🤖 badge on the avatar (defaults to a bot_contributor user.level, which the users info service returns)
 * @param {string} [props.className] - Optional CSS class name
 * @param {Object} [props.style] - Optional inline styles
 * @param {boolean} [props.autoFocus] - Whether to auto focus the input
 * @param {function} [props.onBlur] - Callback function when the input loses focus
 * @param {string} [props.placeholder] - Placeholder text for the input
 */
export function UserAvatar({ user, id: userId, isPremium = undefined, isBot = undefined, className = null, ...other }) {
  if (_.isString(user)) {
    user = { username: user, id: userId || user }
  }

  let { username, id } = user || { username: '?', id: userId || 'undefined' };
  
  id = (id || '').toString();

  const showPremium = isPremium ?? Boolean(user?.isPremium);
  const showBot = isBot ?? user?.level === 'bot_contributor';

  let avatarColorIndex = '0';
  const AVAILABLE_COLORS = 48;
  try {
    avatarColorIndex = (parseInt((id || '000').slice(-2), 16) % AVAILABLE_COLORS).toString();
  } catch (err) {
    console.log('Broken avatar-user');
  }

  let initials = (username || '??').replace(/\s/g, '').slice(0, 2).toUpperCase();

  if (id.startsWith('casual-')) {
    initials = '👁‍🗨';
  }

  if (id === 'sheetScript' || id.includes('-bot') || id === 'gemini') {
    initials = '🤖'
    avatarColorIndex = "other";
    username = id;
  }

  // @ts-ignore
  return <a href={`${window.config.opinautosUrl}/miembros/perfil/${id}`} target={'_blank'}
    className={`avt${avatarColorIndex} avatar-small gen-avatar align-middle ${className || ''}`} title={username} {...other}>
    <span className={'initials'}>{initials}</span>
    {showPremium ? <span className={'avatar-premium-badge'} title={`${username} is Premium`}>💎</span> : null}
    {showBot ? <span className={'avatar-bot-badge'} title={`${username} is a bot`}>🤖</span> : null}
  </a>;
}
